import * as React from 'react';
import clx from 'classnames';
import './ProcedureFrontTableActions.scss';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export interface ProcedureFrontTableActionsProps {
  to: string;
  mobileOnly?: boolean;
}

export function ProcedureFrontTableActions(
  props: ProcedureFrontTableActionsProps
) {
  const { t } = useTranslation();
  return (
    <span
      className={clx('procedure-front-table-cell-actions', {
        'mobile-only': props.mobileOnly
      })}
    >
      <Link to={props.to}>
        <Button>{t('procedures.list.actions.see-detail', 'Dettaglio')}</Button>
      </Link>
    </span>
  );
}
